import { Box, Chip, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import classes from "./FilterChip.module.scss";
import { FiltersChipsNames } from "../../enums/FiltersChipsNames";
import { FilterChipProps } from "../../interfaces/props/FilterChipProps";

const colorMapper: Record<string, string> = {
  [FiltersChipsNames.TYPE]: 'type-color',
  [FiltersChipsNames.SITE]: 'site-color',
  [FiltersChipsNames.TAG]: 'tag-color',
  [FiltersChipsNames.TIP]: 'tip-color',
  [FiltersChipsNames.DATE]: 'date-color'
};

const FilterChip = ({ id, name, entity, onDelete }: FilterChipProps) => {
  const color = useMemo(() => colorMapper[entity], [entity]);
  const onDeleteHandler = useCallback(() => {
    onDelete(id, entity);
  }, [id, entity, onDelete]);

  return (
    <Chip
      className={`${classes.chip} ${classes[color]}`}
      label={
        <Box className='d-flex gap-1'>
          <Typography className='text-base'>{`${entity}:`}</Typography>
          <Typography className='fw-bold'>{name}</Typography>
        </Box>
      }
      deleteIcon={<ClearIcon />}
      onDelete={onDeleteHandler}
    />
  );
};

export default FilterChip;
